import React from "react";
import { Navigate } from "react-router-dom";
import { useCookies } from "react-cookie";

const PrivateRoute = ({children}) => {
    const [cookies, setCookie, removeCookie] = useCookies(['userToken']);
    return !!cookies.userToken ? children : <Navigate to="/" />
}

export default PrivateRoute;